/**
 * @flow
 */

import React from 'react'

import ResponsiveContainer from '../../core/ResponsiveContainer'
import {
  MainContainer,
  IBCricketLogo,
  MainContentContainer,
  Title,
  Image,
  Content
} from './styledComponents'

class LandingSection extends React.Component {
  static defaultProps = {
    title: 'iB Cricket is a product of ProYuga',
    imageURL:
      'https://res.cloudinary.com/due4dmz2b/image/fetch/dpr_auto,w_auto,f_auto,q_auto/https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/team-proyuga/proyuga-logo.svg',
    content:
      'We develop transformative products in Virtual, Augmented and Mixed Reality',
    iBCLogo:
      'https://proyuga-media-assets.s3.ap-south-1.amazonaws.com/ib-cricket-logo-reg.png',
    alt: 'proyuga Logo',
    iBCalt: 'iB Cricket'
  }

  render() {
    const { title, imageURL, content, alt, iBCalt, iBCLogo } = this.props
    return (
      <MainContainer id="team-page-landing-section">
        <ResponsiveContainer>
          <IBCricketLogo src={iBCLogo} alt={iBCalt} />
          <MainContentContainer>
            <Title as="h1"> {title} </Title>
            <Image src={imageURL} alt={alt} />
            <Content> {content} </Content>
          </MainContentContainer>
        </ResponsiveContainer>
      </MainContainer>
    )
  }
}

export default LandingSection



// WEBPACK FOOTER //
// ./src/components/TeamNew/LandingSection/index.js